<script setup lang="ts">
import { useCdnImages } from '../../composables/use-cdn-images'

import type { VodRatingParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  vodRating: VodRatingParagraph['vodRating']
}>()

const { cdnImageUrl } = useCdnImages()
</script>

<template>
  <div class="bx-content bx-typo--vod-epg">
    <h3>
      Bewertung
    </h3>
    <div class="bx-vod-rating bx-typo--vod-rating">
      <img :src="cdnImageUrl('/images/tvmovie/tmdb-logo-vod-rating.svg')"
           alt="TMDB Logo"
           width="300"
           height="129"
           loading="lazy"
           class="tmdb-logo">
      <span>
        <span>
          Bewertung: {{ (vodRating.value ?? 0).toFixed(1).replace('.', ',') }}
        </span>
        / 10
      </span>
    </div>
  </div>
</template>
